// extracted by mini-css-extract-plugin
export default {"title":"style_title__h-Hdq","text":"style_text__+zFzy","box":"style_box__tV795","closeIcon":"style_closeIcon__h8tZI","content":"style_content__EHmDl"};